import { Box, Card, CardActions, CardContent, Collapse, IconButton, type SxProps } from '@mui/material'
import { useEffect, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'

interface AccordionProps {
  color?: string
  colorWidth?: string
  icon?: JSX.Element
  expanded: boolean
  expandButtonKey: string
  baseStyle?: SxProps
  accordionSummary: JSX.Element
  accordionDetails: JSX.Element
  showOptions?: boolean
  optionsElement?: JSX.Element
  dataTestId?: string
  actionButtons?: JSX.Element[]
}

export default function IconAccordion (props: AccordionProps): JSX.Element {
  const [expanded, setExpanded] = useState(false)

  const style = {
    transform: expanded ? 'rotate(180deg)' : '',
    transition: 'transform 150ms ease'
  }

  useEffect(() => {
  }, [])

  const rotate = (): void => {
    setExpanded(!expanded)
  }

  return <Card data-testid={props.dataTestId} sx={{ display: 'flex', ...props.baseStyle }}>
    { (props.icon != null || props.color != null) &&
      <Box data-testid={`${props.dataTestId ?? ''}-colorbox`} sx={{ width: `${props.colorWidth ?? '40px'}`, backgroundColor: `${props.color ?? 'var(--white)'}`, alignContent: 'center', justifyContent: 'center' }}>
        { props.icon }
      </Box>
    }
    <Card sx={{ border: 'none', boxShadow: 'none', width: '100%' }}>
      <Box sx={{ margin: '0px', alignContent: 'center' }}>
        <CardContent sx={{ padding: '0 !important', ml: '1em' }}>
          <Box display='flex' sx={{ alignItems: 'center', width: '100%' }}>
            <Box sx={{ width: '75%' }}>
              {props.accordionSummary}
            </Box>
            <CardActions sx={{ justifySelf: 'right', ml: 'auto' }}>
              {props.showOptions === true && props.optionsElement !== null
                ? <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {props.optionsElement}
                  <IconButton aria-label='expand accordion' data-testid={props.expandButtonKey} onClick={rotate}><ExpandCircleDownIcon sx={{ color: 'var(--grey-700)' }} style={style}/></IconButton>
                </Box>
                : <IconButton aria-label='expand accordion' data-testid={props.expandButtonKey} onClick={rotate}><ExpandMoreIcon style={style}/></IconButton>
              }
            </CardActions>
          </Box>
        </CardContent>
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <CardContent>
            {props.accordionDetails}
          </CardContent>
        </Collapse>
      </Box>
    </Card>
  </Card>
}
